<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">Add Member Diary</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a
              @click="
                openPage(
                  '/memberData/detail?id=' +
                    id_lead_member +
                    '&id_lead=' +
                    id_lead
                )
              "
              class="link-back"
              ><i class="fas fa-arrow-circle-left mr-5"></i>Back</a
            >
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="submitMemberDiary">
          <hr class="short-line left" />
          <div class="row mb-30">
            <div class="col-lg-4">
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member Diary Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.excercise_name" name="member_diary_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('member_diary_name') }}</span>
                </b-col>
              </b-row> -->
              <!-- Nama PT -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Personal Trainer</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    v-validate="'required'"
                    name="personal_trainer"
                    v-model="addData.personal_trainer_id"
                    class="form-control border-bottom"
                  >
                    <option :value="null" selected>Please select</option>
                    <option
                      v-for="(item, index) in dataPT"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{
                    errors.first("personal_trainer")
                  }}</span>
                </b-col>
              </b-row>
              <!-- Schedule Date -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Schedule Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr
                    :config="exportConfig"
                    class="font-13 border-bottom"
                    v-model="addData.schedule_date"
                    name="schedule_date"
                  ></flat-pickr>
                  <span class="error">{{ errors.first("schedule_date") }}</span>
                </b-col>
              </b-row>
              <!-- Session Time -->
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <label>Time</label>
                </b-col>
                <b-col sm="9">
                  <div class="select-time">
                    <flat-pickr
                      :config="timeConfig"
                      v-model="addData.time"
                      name="time"
                      class="form-control border-bottom"
                    ></flat-pickr>
                  </div>
                </b-col>
              </b-row> -->

              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Number Of Session</div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group
                    class="radio-custom-list"
                    @change="changeNumberOfPt"
                    name="nos"
                    v-model="addData.number_of_session"
                  >
                    <b-form-radio
                      class="font-13"
                      v-for="item in numberOfPtSessionList"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.value }}</b-form-radio
                    >
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("nos") }}</span>
                </b-col>
              </b-row> -->

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>How many movement</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    @change="changeMovement"
                    class="form-control border-bottom"
                    v-model="addData.how_many_movement"
                    name="how_many_movement"
                    v-validate="'numeric'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{
                    errors.first("how_many_movement")
                  }}</span>
                </b-col>
              </b-row>

              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <label>Rest Time</label>
                </b-col>
                <b-col sm="9">
                  <div class="select-time">
                    <flat-pickr :config="timeConfig" v-model="addData.rest_time" name="rest_time" class="form-control border-bottom"></flat-pickr>
                  </div>
                </b-col>
              </b-row> -->
            </div>
            <div class="col-lg-8" v-if="addData.how_many_movement != 0">
              <div
                v-for="(item) in addData.how_many_movement"
                :key="item"
              >
                <div style="font-weight: bold">Training Movement</div>
                <hr class="short-line left" />
                <!-- Category -->
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Member Diary Category</div>
                  </b-col>
                  <!-- <b-col sm="4">
                    <b-form-input
                      v-if="multiOptions['select_category_' + item]"
                      v-on:input="onChangeInput(index, 'input_category' + item)"
                      class="form-control border-bottom"
                      name="member_category"
                      placeholder="Enter member diary category"
                      type="text"
                      :disabled="true"
                    ></b-form-input>
                    <b-form-input
                      v-else
                      v-on:input="
                        onChangeInput($event, 'input_category' + item)
                      "
                      class="form-control border-bottom"
                      v-model="addTrainingSession['member_category' + item]"
                      name="member_category"
                      placeholder="Enter member diary category"
                      type="text"
                      :disabled="true"
                    ></b-form-input>
                  </b-col> -->
                  <b-col sm="8">
                    <div class="custom-search-select">
                      <model-select
                        v-on:input="
                          onChangeSelect($event, 'select_category_' + item, 'member_category' + item)
                        "
                        autocomplete="false"
                        :options="listCategory"
                        class="border-bottom"
                        placeholder="Select Category"
                        name="member_category"
                        :isDisabled="multiOptions['input_category' + item]"
                        v-model="addTrainingSession['member_category' + item]"
                      ></model-select>
                    </div>
                    <span class="error">{{
                      errors.first("member_category" + item)
                    }}</span>
                  </b-col>
                </b-row>
                <!-- SubCategory -->
                <!-- <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Member Diary Subcategory</div>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input
                      v-if="multiOptions['select_subcategory_' + item]"
                      v-on:input="
                        onChangeInput($event, 'input_subcategory' + item)
                      "
                      class="form-control border-bottom"
                      name="member_subcategory"
                      placeholder="Enter member diary Subcategory"
                      type="text"
                      :disabled="multiOptions['select_subcategory_' + item]"
                    ></b-form-input>
                    <b-form-input
                      v-else
                      v-on:input="
                        onChangeInput($event, 'input_subcategory' + item)
                      "
                      class="form-control border-bottom"
                      name="member_subcategory"
                      v-model="addTrainingSession['member_subcategory' + item]"
                      placeholder="Enter member diary Subcategory"
                      type="text"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <div class="custom-search-select">
                      <model-select
                        v-on:input="
                          onChangeSelect($event, 'select_subcategory_' + item)
                        "
                        autocomplete="false"
                        :options="listSubcategory"
                        class="border-bottom"
                        placeholder="Please Select"
                        name="member_subcategory"
                        v-model="
                          addTrainingSession['member_subcategory' + item]
                        "
                        :isDisabled="multiOptions['input_subcategory' + item]"
                      ></model-select>
                    </div>
                    <span class="error">{{
                      errors.first("member_subcategory" + item)
                    }}</span>
                  </b-col>
                  <b-col sm="1" style="padding: none">
                    <div v-on:click="reset('member_subcategory' + item, 'select_subcategory_'+item, 'input_subcategory'+item, 'subcat')" style="display: block;margin-left: -14px;margin-top: 5px;color: #f36262;cursor: pointer">
                      <i class="fas fa-trash"></i>
                    </div>
                  </b-col>
                </b-row> -->
                <!-- Activity -->
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Member Diary Activity</div>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-if="multiOptions['select_member_pt_diary_activity_id_' + item] || addTrainingSession['member_category' + item] == 1 || addTrainingSession['member_category' + item] == 148"
                    v-on:input=" onChangeInput($event,'input_member_pt_diary_activity_id' + item)"
                      class="form-control border-bottom"
                      name="reps"
                      type="text"
                      placeholder="Enter member diary"
                      :disabled="multiOptions['select_member_pt_diary_activity_id_' + item] || addTrainingSession['member_category' + item] == 1 || addTrainingSession['member_category' + item] == 148"
                    ></b-form-input>
                    <b-form-input
                      v-else
                      v-on:input="
                        onChangeInput(
                          $event,
                          'input_member_pt_diary_activity_id' + item
                        )
                      "
                      class="form-control border-bottom"
                      name="reps"
                      v-model="
                        addTrainingSession['member_pt_diary_activity_id' + item]
                      "
                      type="text"
                      placeholder="Enter member diary"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <div class="custom-search-select">
                      <model-select
                        v-on:input="
                          onChangeSelect(
                            $event,
                            'select_member_pt_diary_activity_id_' + item
                          )
                        "
                        autocomplete="false"
                        :options="dataDiaryActivity"
                        class="border-bottom"
                        placeholder="Please Select"
                        name="member_pt_diary_activity_id"
                        v-model="
                          addTrainingSession[
                            'member_pt_diary_activity_id' + item
                          ]
                        "
                        :isDisabled="
                          multiOptions[
                            'input_member_pt_diary_activity_id' + item
                          ]
                        "
                      ></model-select>
                    </div>
                    <span class="error">{{
                      errors.first("member_pt_diary_activity_id" + item)
                    }}</span>
                  </b-col>
                  <b-col sm="1" style="padding: none">
                    <div v-on:click="reset('member_pt_diary_activity_id' + item, 'select_member_pt_diary_activity_id_'+item, 'input_member_pt_diary_activity_id'+item, 'activity')" style="display: block;margin-left: -14px;margin-top: 5px;color: #f36262;cursor: pointer">
                      <i class="fas fa-trash"></i>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Sets</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['sets' + item]"
                      name="sets"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{ errors.first("sets" + item) }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Reps</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['reps' + item]"
                      name="reps"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{ errors.first("reps" + item) }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Weight / Intensity</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['weight' + item]"
                      name="weight"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{
                      errors.first("weight" + item)
                    }}</span>
                  </b-col>
                </b-row>
                <!-- <b-row class="mb-20">
                  <b-col sm="3">
                    <div>One RM</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['one_rm' + item]"
                      name="one_rm"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{
                      errors.first("one_rm" + item)
                    }}</span>
                  </b-col>
                </b-row> -->
                <!-- <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Dist</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['dist' + item]"
                      name="dist"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{ errors.first("dist" + item) }}</span>
                  </b-col>
                </b-row> -->
                <!-- <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Intensity</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      class="form-control border-bottom"
                      v-model="addTrainingSession['intensity' + item]"
                      name="intensity"
                      type="text"
                    ></b-form-input>
                    <span class="error">{{
                      errors.first("intensity" + item)
                    }}</span>
                  </b-col>
                </b-row> -->
                <!-- notes -->
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Notes</div>
                  </b-col>
                  <b-col sm="9">
                     <textarea class="form-control w-100" rows="3" v-model="addTrainingSession['notes' + item]" name="notes" type="text"></textarea>
                    <span class="error">{{
                      errors.first("notes" + item)
                    }}</span>
                  </b-col>
                </b-row>
              </div>

              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member</div>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember" class="border-bottom" name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('member_name') }}</span>
                </b-col>
              </b-row> -->
            </div>
            <!-- <div class="col-12">
              <div class="mb-5">Notes</div>
              <textarea class="form-control w-100" rows="3" v-model="addData.notes" name="notes" type="text"></textarea>
            </div> -->
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'
export default {
  name: "addMemberDiary",
  components: {
    ModelSelect,
  },
  mixins:[Mixin],
  data: function () {
    return {
      config: {},
      dataPT: [],
      member_category: null,
      member_subcategory: null,
      dataDiaryActivity: [],
      listSubcategory: [],
      listCategory: [],
      id_lead_member: "",
      id_lead: "",
      timeConfig: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        defaultDate: "00:00:00",
        static: true,
        time_24hr: true,
      },
      exportConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        // onChange: this.onChange
      },
      addData: {
        schedule_date: moment(new Date()).format("YYYY-MM-DD"),
        member_pt_diary_activity_id: null,
        member_id: null,
        personal_trainer_id: null,
        how_many_movement: 0,
        number_of_session: 1,
      },
      multiOptions: {}, // untuk disable form
      addTrainingSession: {},
      addTrainingSessionUpload: [],
      numberOfPtSessionList: [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
      ],
      getCategory: "",
      getSubcategory: "",
      optionsMember: [{ value: null, text: "Please select" }],
    };
  },
  methods: {
    reset(data, select, input, type = '') {
      const sub = this.listSubcategory.filter((m) => m.value == this.addTrainingSession[data])
      const activity = this.dataDiaryActivity.filter((m) => m.value == this.addTrainingSession[data])
      // console.log('SUB', sub[0].value)
      // console.log('ACTIVITY',activity)
      if (sub != undefined || sub != null) {
        if (type == 'subcat') {
          this.deleteSubCategoryAndActivityData(sub[0].value, type)
        }
      }

      if (activity != undefined || activity != null) {
        if (type == 'activity') {
          this.deleteSubCategoryAndActivityData(activity[0].value, type)
        }
      }

      var object = this.addTrainingSession
      delete object[data]
      this.addTrainingSession = {}
      Object.assign(this.addTrainingSession, object)

      var selects = this.multiOptions
      delete selects[select]
      delete selects[input]
      this.multiOptions = {}
      Object.assign(this.multiOptions, selects)
    },
    deleteSubCategoryAndActivityData(id, type) {
      if (type == 'subcat') {
        axios.get("crm/v1/member_pt_diary_subcategory/delete/" + id).then(response => {
          console.log(response)
          this.fetchData()
        })
      }

      if (type == 'activity') {
        axios.get("crm/v1/member_pt_diary_activity/delete/" + id).then(response => {
          console.log(response)
          this.fetchData()
        })
      }
    },
    onChangeSelect(index, data, key) {
      this.multiOptions[data] = index == null ? false : true;
      if (data.includes('select_category')) {
        this.getDiaryActivity(this.addTrainingSession[key])
      }
      // console.log(this.multiOptions)
    },
    getDiaryActivity(category_id) {
      axios
        .get("crm/v1/member_pt_diary_activity?category_id=" + category_id)
        .then(response => {
          this.dataDiaryActivity = []
          // this.dataDiaryActivity = response.data.data.rows;
          // console.log('test', response.data.data.rows)
           this.dataDiaryActivity.push({
              value: null,
              text: 'Please select'
            })
          for (let i = 0; i < response.data.data.rows.length; i++) {
            this.dataDiaryActivity.push({
              value: response.data.data.rows[i].id,
              text: response.data.data.rows[i].excercise_name
            })
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    onChangeInput(index, event) {
      this.multiOptions[event] = index ? true : false;
    },
    changeMovement(event) {
      this.addData.how_many_movement = Number(event);
    },
    changeNumberOfPt(event) {
      this.addData.number_of_session = event;
      // this.numberOfPtSessionList = Number(event);
    },
    changeDiaryCategory(event) {
      // console.log('test', event)
      // axios
      //   .get("crm/v1/member_pt_diary_subcategory?category=" + event)
      //   .then(response => {
      //     this.listSubcategory = response.data.data;
      //     // console.log('test', response.data.data.rows)
      //   })
      //   .catch(error => {
      //     console.log("error", error);
      //   });
    },
    changeDiarySubcategory(event) {
      // axios
      //   .get("crm/v1/member_pt_diary_activity?subcategory=" + event)
      //   .then(response => {
      //     this.dataDiaryActivity = response.data.data.rows;
      //     // console.log('test', response.data.data.rows)
      //   })
      //   .catch(error => {
      //     console.log("error", error);
      //   });
    },
    submitMemberDiary() {
      this.addTrainingSessionUpload = [];
      this.addData.member_id = this.id_lead_member;
      for (let i = 0; i < this.addData.how_many_movement; i++) {
        var obj = {};
        for (
          let ob = 0;
          ob < Object.keys(this.addTrainingSession).length;
          ob++
        ) {
          var char = Object.keys(this.addTrainingSession)[ob].charAt(
            Object.keys(this.addTrainingSession)[ob].length - 1
          );
          if (Number(char) == i + 1) {
            obj[
              Object.keys(this.addTrainingSession)[ob].slice(0, -1)
            ] = Object.values(this.addTrainingSession)[ob];
            obj["schedule_date"] = this.addData.schedule_date;
            obj["member_id"] = this.addData.member_id;
            obj["personal_trainer_id"] = this.addData.personal_trainer_id;
            obj["time"] = this.addData.time + ":00";
            obj["how_many_movement"] = this.addData.how_many_movement;
            obj["number_of_session"] = this.addData.number_of_session;
          }
        }
        this.addTrainingSessionUpload.push(obj);
      }

      // looping for uploads

      this.$validator.validateAll().then((result) => {
        // console.log(result)
        if (result) {
          // this.addData.member_id = this.id_lead_member;
          console.log(this.addTrainingSessionUpload);
          for (let u = 0; u < this.addTrainingSessionUpload.length; u++) {
            // console.log(this.addTrainingSessionUpload[u])
            axios
              .post("crm/v1/member_pt_diary", this.addTrainingSessionUpload[u])
              .then((response) => {
                if (u + 1 == this.addTrainingSessionUpload.length) {
                  // console.log('test', response)
                  this.$router.push(
                    "/memberData/detail?id=" +
                      this.id_lead_member +
                      "&id_lead=" +
                      this.id_lead
                  );
                  this.$toast.success("data saved successfully!", "Success", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff",
                  });
                }
              })
              .catch((error) => {
                console.log("error", error.response);
                // console.log('error', error.response.data.error)
                if (error.response.data) {
                  this.$toast.success(error.response.data.error, "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff",
                  });
                } else {
                  this.$toast.success("Cant saved data!", "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff",
                  });
                }
              });
          }
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    fetchData() {
      // turn off autocomplete
      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id");
        for (var i = 0; inputElements[i]; i++) {
          if (
            inputElements[i].className &&
            inputElements[i].className.indexOf("disableAutoComplete") != -1
          ) {
            inputElements[i].setAttribute("autocomplete", "off");
          }
        }
      }
      // axios
      //   .get("fitness/v1/member/data_entry")
      //   .then((response) => {
      //     var dataMember = response.data.data.rows;
      //     for (var i = 0; i < dataMember.length; i++) {
      //       let memberBranchId;
      //       if (!dataMember[i].branch_id) {
      //         memberBranchId =
      //           "(FT-" +
      //           dataMember[i].id +
      //           ") " +
      //           dataMember[i].first_name +
      //           " " +
      //           dataMember[i].last_name;
      //       } else {
      //         memberBranchId =
      //           "(" +
      //           dataMember[i].branch.codename +
      //           "-" +
      //           dataMember[i].id +
      //           ") " +
      //           dataMember[i].first_name +
      //           " " +
      //           dataMember[i].last_name;
      //       }
      //       // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: dataMember[i].id, text: dataMember[i].first_name + ' ' + dataMember[i].last_name})
      //       var dataComplete = Object.assign(
      //         {},
      //         { value: null, text: "Please select" },
      //         { value: dataMember[i].id, text: memberBranchId }
      //       );
      //       this.optionsMember.push(dataComplete);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("error", error);
      //   });
      this.getMember()
      axios
        .get("fitness/v1/personal_training")
        .then((response) => {
          this.dataPT = response.data.data.rows;

          if (Auth.Session.get().paradigm_role == 7) {
            this.dataPT = this.dataPT.filter(item => item.id == Auth.Session.get().paradigm_id)
            this.addData.personal_trainer_id = Auth.Session.get().paradigm_id
          }
          // console.log('test', response.data.data.rows)
        })
        .catch((error) => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/member_pt_diary_category")
        .then((response) => {
          // this.listCategory = response.data.data;
          this.listCategory.push({
            value: null,
            text: "Please select",
          });
          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].name != "") {
              this.listCategory.push({
                value: response.data.data[i].id,
                text: response.data.data[i].name,
              });
            }
          }
          // console.log('test', response.data.data)
        })
        .catch((error) => {
          console.log("error", error);
        });

      axios
        .get("crm/v1/member_pt_diary_subcategory")
        .then((response) => {
          this.listSubcategory = []
          this.listSubcategory.push({
            value: null,
            text: "Please select",
          });
          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].name != "") {
              this.listSubcategory.push({
              value: response.data.data[i].id,
              text: response.data.data[i].name,
            });
            }

          }
          // console.log('test', response.data.data.rows)
        })
        .catch((error) => {
          console.log("error", error);
        });

      axios
        .get("crm/v1/member_pt_diary_activity")
        .then((response) => {
          this.dataDiaryActivity = []
          // this.dataDiaryActivity = response.data.data.rows;
          // console.log('test', response.data.data.rows)
          this.dataDiaryActivity.push({
            value: null,
            text: "Please select",
          });
          for (let i = 0; i < response.data.data.rows.length; i++) {
            if (response.data.data.rows[i].excercise_name != "") {
              this.dataDiaryActivity.push({
                value: response.data.data.rows[i].id,
                text: response.data.data.rows[i].excercise_name,
              });
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  created() {
    this.fetchData();
    this.id_lead_member = this.$route.query.id;
    this.id_lead = this.$route.query.id_lead;
  },
};
</script>

<style></style>
